import Utils from '@lcsc-ui/utils/Utils';
import Image from 'next/image';
import { toast as message } from 'sonner';

import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';

export default function SharePopup({ open, onClose }) {
  const handleCopyLink = () => {
    const url = window.location.href;
    Utils.copyTextToClipboard(url);
    message.success('复制成功');
    onClose();
  };

  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent side="bottom" className="p-0 rounded-t-[8px] max-h-[80vh] overflow-hidden">
        <SheetHeader className="p-4">
          <SheetTitle>分享至</SheetTitle>
        </SheetHeader>
        <div className="h-[200px] flex items-center justify-center">
          <div className="flex flex-col items-center text-[14px]" onClick={handleCopyLink}>
            <Image
              src="https://static.szlcsc.com/ecp/assets/app/product-detail/link.png"
              alt="复制链接"
              width={48}
              height={48}
            ></Image>
            <span className="mt-[16px]">复制链接</span>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
